import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DtmService } from 'src/app/services/dtm.service';
import { PaymentFormComponent } from 'src/app/shared/components/payment-form/payment-form.component';
import { CreditCardData } from 'src/app/shared/model/credit-card-data';
import { Discount } from 'src/app/shared/model/discount';
import { PaymentMethodOption } from 'src/app/shared/model/payment-method-option';
import { Product } from 'src/app/shared/model/product';
import { RenewalData } from 'src/app/shared/model/renewal-data';
import { SelfAttendanceData } from 'src/app/shared/model/self-attendance-data';
import { EarlyRenewalService } from 'src/app/shared/services/early-renewal.service';
import { SelfAttendanceService } from 'src/app/shared/services/self-attendance.service';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';

import {
  authReasonCode,
  bankBillet2ndCopyErrors,
  pix2ndCopyErrors,
  paymentMethodErrors,
  braspagReasonCode, adyenReasonCode,
  errorMapping,
  handleIntegrationError, paymentChangeDataError
} from '../../shared/constants/errors';
import { DialogData } from 'src/app/shared/model/dialog-data';
import { MatDialog } from '@angular/material/dialog';
import { DialogAlertComponent } from 'src/app/shared/components/dialog-alert/dialog-alert.component';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { LoadingComponent } from 'src/app/shared/components/loading/loading.component';
import { Dtm, getDtm } from 'src/app/shared/enum/dtm';
import { PresetName } from 'src/app/shared/model/hero-data';

@Component({
    selector: 'pme-early-renewal',
    templateUrl: './early-renewal.component.html',
    styleUrls: ['./early-renewal.component.scss'],
    standalone: false
})
export class SelfAttendanceEarlyRenewalComponent implements OnInit {

  payload: any;
  classificationIdentifier: string;
  renewalInfo: RenewalData;
  hashString: string;
  redirectUrl: string;
  originOfRequest: string;
  contractCode: string;
  businessId: string;
  userId: string;
  couponIdentifier: string;
  selfAttendanceData: SelfAttendanceData;
  selfAttendanceHeroData: any;
  paymentMethod: string;
  location: Location;
  currentPaymentMethod: string;

  heroData: any = {};
  currentPlanData: any;
  showHero: boolean;
  currentProduct: Product;

  changePaymentMethodDiscount: Discount;
  changePaymentMethodDiscountFound: boolean;
  discountBadgeCreditCard: string;
  termOfUse: string;

  @ViewChild(PaymentFormComponent) paymentForm: PaymentFormComponent;

  showForm: boolean;
  paymentOptions: Array<PaymentMethodOption>;
  showCurrentPlan: boolean;
  buttonName: any;

  paymentChangeMessage: string;

  creditCardsData: CreditCardData[];
  maxLimitCreditCards: boolean;
  creditCardData: CreditCardData;

  showErrorHero: boolean = false;

  constructor(
    private earlyRenewalService: EarlyRenewalService,
    private route: ActivatedRoute,
    public sessionStorageService: SessionStorageService,
    private selfAttendanceService: SelfAttendanceService,
    public dtmService: DtmService,
    public dialog: MatDialog,
    private loading: LoadingService,
    private router: Router,

  ) {

    this.buttonName = 'Finalizar alteração';

    this.openDialogSpinner();
    this.classificationIdentifier = this.sessionStorageService.getClassification(route);
    this.route.queryParams.subscribe((params) => {
      this.originOfRequest = params.origin;
      this.hashString = params.hash;
      this.userId = params.userId;
      this.businessId = params.businessId;
      this.couponIdentifier = params.couponIdentifier;
      this.sessionStorageService.setCustomData('selfAttendance','true');
    });

    this.payload = {
      classificationIdentifier : this.classificationIdentifier,
      userId: this.userId,
      businessId: this.businessId,
      couponIdentifier: this.couponIdentifier,
      simulate: true
    }

    this.dtmService.pageLoaded(Dtm.AntecipacaoRenovacaoClientePagamento, this.sessionStorageService.getIsLogged(), getDtm(Dtm.AntecipacaoRenovacaoClientePagamento, this.classificationIdentifier))
    this.dtmService.userLoaded({
      userId: this.userId,
      businessId: this.businessId
    });
  }

  ngOnInit(): void {

    this.selfAttendanceService.getStoredCreditCards(this.userId, this.businessId, this.hashString).subscribe(results => {
      this.creditCardsData = results[0].length ? results[0] : null;
      this.maxLimitCreditCards = results[1];
    });

    this.selfAttendanceService.getStoredCreditCard(this.userId, this.businessId).subscribe(r => {
      this.creditCardData = r;
    });


    this.selfAttendanceService.getPaymentChangeData(this.businessId, this.userId, this.classificationIdentifier, this.originOfRequest).subscribe(
      (selfAttendanceData: SelfAttendanceData) => {
        selfAttendanceData.businessId = this.businessId;
        selfAttendanceData.userId = this.userId;

        this.termOfUse = selfAttendanceData.tdu;

        this.selfAttendanceService.setCurrentSelfAttendanceData(selfAttendanceData);

        if (selfAttendanceData.paymentOptions && selfAttendanceData.contract) {
          this.dtmService.productsLoaded([{
            identifier: selfAttendanceData.contract.product.identifier,
            classificationName: selfAttendanceData.contract.product.classificationName // 'Saúde do seu negócio'
          }]);

          this.currentPaymentMethod = selfAttendanceData.contract.paymentMethod.identifier;

          this.currentProduct = selfAttendanceData.contract.product;

          this.showCurrentPlan = true;
          this.currentPlanData = {}
          if (selfAttendanceData.bankBilletData) {
            this.currentPlanData.planName = selfAttendanceData.bankBilletData.planName;
            this.currentPlanData.invoiceDate = selfAttendanceData.bankBilletData.invoiceDate;
            this.currentPlanData.totalValue = selfAttendanceData.bankBilletData.totalValue;
          } else if (selfAttendanceData.pixData) {
            this.currentPlanData.planName = selfAttendanceData.pixData.planName;
            this.currentPlanData.invoiceDate = selfAttendanceData.pixData.invoiceDate;
            this.currentPlanData.totalValue = selfAttendanceData.pixData.totalValue;
          } else if (selfAttendanceData.creditCardData) {
            this.currentPlanData.planName = selfAttendanceData.creditCardData.planName;
            this.currentPlanData.invoiceDate = selfAttendanceData.creditCardData.invoiceDate;
            this.currentPlanData.totalValue = selfAttendanceData.creditCardData.totalValue;
            this.currentPlanData.creditCard = selfAttendanceData.creditCardData.getFinalNumber();
            this.currentPlanData.brand = selfAttendanceData.creditCardData.getBrandCSSMatching();

          }

          this.dtmService.sendPageLoadEvent();
          this.earlyRenewalService.simulateOrInvoice(this.payload).subscribe({
            next: (res: RenewalData) => {
              this.renewalInfo = new RenewalData(res);
              //Removing BANK_BILLET as payment option
              this.paymentOptions = this.renewalInfo.paymentOptions.filter( item => { return item.identifier === 'CREDIT_CARD'});
              this.showForm = true;
              this.closeDialogSpinner();
            },
            error: (error:any) => {
              this.closeDialogSpinner();
               this.selfAttendanceHeroData = {
                  type: 'error',
                  title: 'Serviço indisponível!',
                  contents: ['Você está fora do período de renovação antecipada.'],
                }
              this.showCustomError('paymentChangeError', error);
            }
          });

        }
      },
      (error) => {
         this.selfAttendanceHeroData = {
          type: 'error',
          title: 'Serviço indisponível!',
          contents: ['O Serviço que tentou acessar no momento está indisponível.'],
         }
        this.showCustomError('paymentChangeDataError', error);
        this.closeDialogSpinner();
      }
    );
  }

  onPaymentChangePerform(paymentData) {

    this.dtmService.customClickEvent(this.buttonName);

    let requestData: any = {};
    requestData.paymentMethodIdentifier = paymentData.identifier;
    requestData.businessId = this.businessId;
    requestData.userId = this.userId;

    requestData.service = this.originOfRequest;

    if (paymentData.identifier === 'CREDIT_CARD') {
      requestData.defaultCard = paymentData.defaultCard;
      requestData.saveCard = paymentData.saveCard;
      requestData.nickname = paymentData.nickname;
      requestData.accountPaymentDataId = paymentData.accountPaymentDataId;

      if (paymentData.isAdyen) {
        requestData.cardNumber = paymentData.card.cardNumber;
        requestData.cardHolder = paymentData.card.cardHolder;
        requestData.cardBrand = paymentData.card.brand;
        requestData.encryptedCardNumber = paymentData.card.encryptedCardNumber;
        requestData.encryptedCardValidityMonth = paymentData.card.encryptedCardValidityMonth;
        requestData.encryptedCardValidityYear = paymentData.card.encryptedCardValidityYear;
        requestData.encryptedCardSecurityCode = paymentData.card.encryptedCardSecurityCode;
        requestData.isAdyen = paymentData.isAdyen;
        requestData.paymentToken = "";
      }
      {
        requestData.cardNumber = this.maskCreditCardNumber(paymentData.card.cardNumber);
        requestData.cardHolder = paymentData.card.cardHolder;
        requestData.cardBrand = paymentData.card.brand;
        requestData.expirationMonth = this.getExpirationMonth(paymentData.card.cardValidityDate);
        requestData.expirationYear = this.getExpirationYear(paymentData.card.cardValidityDate);
        requestData.paymentToken = "";
      }
      if (paymentData.paymentConditionIdentifier) {
        requestData.paymentConditionIdentifier = paymentData.paymentConditionIdentifier;
      } else {
        this.paymentOptions.forEach((paymentOption) => {
          if (paymentOption.identifier === 'CREDIT_CARD') {
            if (paymentOption.paymentConditionOptions && paymentOption.paymentConditionOptions.length) {
              let paymentConditionOptions = paymentOption.paymentConditionOptions.sort((a, b) => {
                return a.installments - b.installments;
              });

              requestData.paymentConditionIdentifier = paymentConditionOptions[paymentConditionOptions.length - 1].identifier;
            } else {
              requestData.paymentConditionIdentifier = 'creditCard1X';
            }
          }
        })

      }
    }

    requestData.productClassification = this.classificationIdentifier;

    this.selfAttendanceService.changePaymentMethod(requestData).subscribe(
      (selfAttendanceData: SelfAttendanceData) => {
        selfAttendanceData.businessId = this.businessId;
        selfAttendanceData.userId = this.userId;

        selfAttendanceData.service = PresetName.EarlyRenewal;

        this.payload.simulate = false;
        this.earlyRenewalService.simulateOrInvoice(this.payload).subscribe({
          next: (res: RenewalData) => {
            this.renewalInfo = new RenewalData(res);
            selfAttendanceData.contract = this.renewalInfo.contract;
            selfAttendanceData.creditCardData.totalValue = this.renewalInfo.finalValue;
            selfAttendanceData.contract.nextRecurrenceDate = this.renewalInfo.renewalDates.renewalFinalDate;

            if(selfAttendanceData.contract.paymentMethod.identifier === 'ADYEN') selfAttendanceData.contract.paymentMethod.identifier = 'CREDIT_CARD';
            this.selfAttendanceService.setCurrentSelfAttendanceData(selfAttendanceData);
            if(this.renewalInfo.contract.paymentMethod.identifier === 'PIX'){
              this.selfAttendanceService.getPix2ndCopy(this.businessId, this.userId, this.classificationIdentifier).subscribe({
                next: (res) => {
                  selfAttendanceData.pixData = res.pixData;
                  this.router.navigate(['../sucesso'], { relativeTo: this.route });
                },
                error: (res:any) => {
                  this.showCustomError('pix2ndCopyError', res);
                  this.closeDialogSpinner();
                }
              });
            }else {
              this.router.navigate(['../sucesso'], { relativeTo: this.route });
            }
          },
          error: (error:any) => {
            this.showCustomError('paymentChangeError', error);
          }
        });
        this.closeDialogSpinner();
      },
      (error) => {
        this.showCustomError('paymentChangeError', error);
        this.closeDialogSpinner();
      }
    )



  }

  onPaymentMethodSelected(paymentMethod) {
      switch(paymentMethod){
        case 'CREDIT_CARD':
          this.paymentMethod = "Cartão de Crédito";
          break;
        case 'PIX':
          this.paymentMethod = "PIX";
          break;
      }
  }

  showCustomError(customErrorKey: string, integrationError?: any) {
    let integrationErrorMessage: any;

    switch (customErrorKey) {
      case "termOfUsedIntegrationError":
        this.paymentForm.addValidationError(
          errorMapping[customErrorKey]
        );

        integrationErrorMessage = handleIntegrationError(integrationError);
        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: errorMapping[customErrorKey],
        });
        break;
      case "invalidPaymentOption":
        this.paymentForm.addValidationError(
          errorMapping[customErrorKey]
        );

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: "PaymentOptionInválido",
          errorMessage: errorMapping[customErrorKey],
        });
        break;
      case "paymentChangeDataError":
        integrationErrorMessage = this.showCustomHeroError(
          integrationError,
          "paymentChangeDataError"
        );

        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        break;
      case "paymentChangeError":
        integrationErrorMessage = this.handlePaymentChange(integrationError);

        if (integrationErrorMessage.userMessage.includes("FRAUDNET_REJECT")) {
          this.openErrorDialog(integrationErrorMessage.userMessage, { customErrorKey });
        } else {
          if (integrationErrorMessage.context === "Fraudnet") {
            this.paymentForm.disableSubmit = true;
          }
          this.paymentForm.addValidationError(
            integrationErrorMessage.errors[0].text
          );
        }


        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        break;
      case "authenticationError":
        integrationErrorMessage = this.showCustomHeroError(
          integrationError,
          "authenticationError"
        );

        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        this.showErrorHero = true;
        break;
      case "bankBillet2ndCopyError":
        integrationErrorMessage = this.showCustomHeroError(
          integrationError,
          "bankBillet2ndCopyError"
        );

        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        this.showErrorHero = true;
        break;
      case "pix2ndCopyError":
        integrationErrorMessage = this.showCustomHeroError(
          integrationError,
          "pix2ndCopyError"
        );

        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        this.showErrorHero = true;
        break;
      case "paymentMethodError":
        integrationErrorMessage = this.showCustomHeroError(
          integrationError,
          "paymentMethodError"
        );

        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        this.showErrorHero = true;
        break;
      default:
        break;
    }

    if (this.showForm) {
      this.paymentForm.submitting = false;
      this.paymentForm.enableFields("all");
    }
  }

  showCustomHeroError(error, type) {
    let resultError: any = {};

    try {
      if (typeof error === "string") {
        error = JSON.parse(error);
      }

      if (error.status && error.error) {
        resultError.status = error.status;
        resultError.endpoint = error.url;
        resultError.name = error.name;

        resultError.handledError = !!error.error._messages.filter((message) => {
          return message.code !== null;
        });

        resultError.errors = error.error._messages.filter((message) => {
          return message.type === "ERROR";
        });

        resultError.warnings = error.error._messages.filter((message) => {
          return message.type === "WARNING";
        });

        resultError.errorString = `${resultError.status}:${resultError.name}:${resultError.endpoint
          }:${JSON.stringify(resultError.errors)}:${JSON.stringify(
            resultError.warnings
          )}`;

        resultError.userMessage = error.error._messages[0].text;
        resultError.code = error.error._messages[0].code;

        switch (type) {
          case "authenticationError":
            if (authReasonCode[resultError.code]) {
              this.heroData.type = "error";
              this.heroData.title = authReasonCode[resultError.code].title;
              this.heroData.contents =
                authReasonCode[resultError.code].contents;
            } else {
              this.heroData.type = "error";
              this.heroData.title = "Serviço indisponível!";
              this.heroData.contents = [
                "O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.",
              ];
            }
            break;
          case "bankBillet2ndCopyError":
            if (bankBillet2ndCopyErrors[resultError.code]) {
              this.heroData.type = "error";
              this.heroData.title =
                bankBillet2ndCopyErrors[resultError.code].title;
              this.heroData.contents = bankBillet2ndCopyErrors[resultError.code].contents;
            } else {
              this.heroData.type = "error";
              this.heroData.title = "Serviço indisponível!";
              this.heroData.contents = [
                "O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.",
              ];
            }
            break;
          case "pix2ndCopyError":
            if (pix2ndCopyErrors[resultError.code]) {
              this.heroData.type = pix2ndCopyErrors[resultError.code].type ? pix2ndCopyErrors[resultError.code].type : "error";
              this.heroData.title = pix2ndCopyErrors[resultError.code].title;
              this.heroData.contents = pix2ndCopyErrors[resultError.code].contents;
            } else {
              this.heroData.type = "warn";
              this.heroData.title = "Serviço indisponível!";
              this.heroData.contents = [
                "O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.",
              ];
            }
            break;
          case "paymentMethodError":
            if (paymentMethodErrors[resultError.code]) {
              this.heroData.type = "warn";
              this.heroData.title =
                paymentMethodErrors[resultError.code].title;
              this.heroData.contents = paymentMethodErrors[resultError.code].contents;
            } else {
              this.heroData.type = "warn";
              this.heroData.title = "Serviço indisponível!";
              this.heroData.contents = [
                "O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.",
              ];
            }
            break;
          case "paymentChangeDataError":
            if (paymentChangeDataError[resultError.code]) {
              this.heroData.type = resultError.code === '3' ? "warn" : "error";
              this.heroData.title = paymentChangeDataError[resultError.code].title;
              this.heroData.contents = paymentChangeDataError[resultError.code].contents;
            } else {
              this.heroData.type = "error";
              this.heroData.title = "Serviço indisponível!";
              this.heroData.contents = [
                "O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.",
              ];
            }
            break;
          default:
            this.heroData.type = "error";
            this.heroData.title = "Serviço indisponível!";
            this.heroData.contents = [
              "O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.",
            ];
            break;
        }
      }
    } catch (e) {
      console.error(e);
      resultError.errorString = JSON.stringify(error);
      this.heroData.type = "error";
      this.heroData.title = "Serviço indisponível!";
      this.heroData.contents = [
        "O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.",
      ];
    }

    this.heroData.showButton = true;
    this.heroData.buttonName = "Ir para área logada";
    this.heroData.redirectURL = this.redirectUrl;

    this.showHero = true;
    return resultError;
  }

  handlePaymentChange(error: any): any {
    let resultError: any = {};

    try {
      if (typeof error === "string") {
        error = JSON.parse(error);
      }

      if (error.status && error.error) {
        resultError.status = error.status;
        resultError.endpoint =
          error.url && error.url.substring(error.url.indexOf("/api/1") + 6);
        resultError.name = error.name;

        resultError.handledError = !!error.error._messages.filter((message) => {
          return message.code !== null;
        });

        resultError.errors = error.error._messages.filter((message) => {
          return message.type === "ERROR";
        });

        resultError.warnings = error.error._messages.filter((message) => {
          return message.type === "WARNING";
        });

        let parseObj;
        try {
          parseObj = JSON.parse(resultError.errors[0].text);
        } catch (err) { }

        if (parseObj && parseObj.context !== undefined) {
          resultError.context = parseObj.context;
          resultError.userMessage = parseObj.message;
          resultError.errorCode = resultError.errors[0].code || parseObj.code;
          resultError.errors[0].text = resultError.userMessage;
        } else {
          resultError.userMessage = resultError.errors[0].text;
          resultError.errorCode = resultError.errors[0].code;
        }

        resultError.errorString = `${resultError.context || "SYDLE"}:HTTP:${resultError.errorCode || resultError.status
          }:POST/${resultError.endpoint}:${JSON.stringify(
            resultError.errors.map(({ text }) => text)
          )}:${JSON.stringify(resultError.warnings)}`;

        if (braspagReasonCode[resultError.userMessage]) {
          resultError.userMessage = braspagReasonCode[resultError.userMessage];
        } else if (adyenReasonCode[resultError.userMessage]) {
          resultError.userMessage = adyenReasonCode[resultError.userMessage];
        } else if (
          resultError.userMessage.indexOf("java") >= 0 ||
          resultError.userMessage.indexOf("Java") >= 0 ||
          resultError.userMessage.indexOf("Script") >= 0 ||
          resultError.userMessage.indexOf("script") >= 0 ||
          resultError.userMessage.indexOf("elastic") >= 0 ||
          resultError.userMessage.indexOf("Elastic") >= 0
        ) {
          resultError.userMessage =
            "Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.";
        }
      }
    } catch (e) {

    }

    return resultError;
  }

  openDialogSpinner(): void {
    this.closeDialogSpinner();
    this.dialog.open(LoadingComponent, {
      disableClose: true,
      width: "400px",
      panelClass: "pme-dialog-loading-panel",
      backdropClass: 'pme-dialog-loading-backdrop'
    });
  }

  openErrorDialog(dialogData, params?) {
    const data = DialogData.fromPreset(dialogData, params);

    const dialogRef = this.dialog.open(DialogAlertComponent, {
      disableClose: true,
      panelClass: "pme-dialog-alert-panel",
      autoFocus: false,
      data: data,
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.changeToBankBillet) {
        this.loading.addTask()

        this.selfAttendanceService.getBankBillet2ndCopy(this.businessId, this.userId, this.classificationIdentifier).subscribe(
          (selfAttendanceData) => {
            if (selfAttendanceData && selfAttendanceData.bankBilletData) {
              selfAttendanceData.businessId = this.businessId;
              selfAttendanceData.userId = this.userId;
              this.selfAttendanceService.setCurrentSelfAttendanceData(selfAttendanceData);
              this.router.navigate(['../sucesso'], { relativeTo: this.route });
              this.loading.finishTask();
            }
          },
          (error) => {
            this.showCurrentPlan = false;
            this.showForm = false;
            this.showCustomError('bankBillet2ndCopyError', error);
            this.loading.finishTask();
          }
        )
      }
    });
  }

  closeDialogSpinner(): void {
    this.dialog.closeAll();
  }

  maskCreditCardNumber(cardNumber: string): string {
    const unmaskedValue = cardNumber.substr(cardNumber.length - 4, 4);
    let maskedValue = cardNumber.substr(0, cardNumber.length - 4);
    maskedValue = maskedValue.split(' ').map(
      digitGroup => {
        let maskedGroup = '';
        while (maskedGroup.length < digitGroup.length) {
          maskedGroup += '*';
        }
        return maskedGroup;
      }
    ).join(' ');
    return maskedValue + unmaskedValue;
  }

  getExpirationMonth(expirationDate) {
    if (expirationDate) {
      let expirationMonth = expirationDate.split("/")[0];
      if (expirationMonth.length === 1) {
        return '0' + expirationMonth;
      } else {
        return expirationMonth;
      }
    } else {
      return '';
    }
  }

  getExpirationYear(expirationDate) {
    if (expirationDate) {
      let expirationYear = expirationDate.split("/")[1];
      return "20" + expirationYear;
    } else {
      return '';
    }
  }

  handleDeleteCreditCard(accountPaymentDataId: string): void {
		this.loading.addTask(2);
		this.selfAttendanceService.removeCreditCard(this.userId, this.businessId, accountPaymentDataId)
			.subscribe(results => {
				this.creditCardsData = results[0].length ? results[0] : null;
				this.maxLimitCreditCards = results[1];
				this.loading.finishTask();
			}, () => this.loading.finishTask());

		this.loading.finishTask();
	}
}
